import React from 'react'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import get from 'lodash/get'
import numeral from 'numeral'

import left_arrow from '../../../../static/images/left-arrow.svg'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'

export default class ProjectRevenueTable extends React.Component {
  state = {
    id: '',
    collapse_overall: false,
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
      && JSON.stringify(nextState) === JSON.stringify(this.state)) return false
    return true
  }

  render() {
    const canSeeOverviewStandard = get(this.props, 'canSeeOverviewStandard')
    const canSeeOverviewActual = get(this.props, 'canSeeOverviewActual')
    const activeToggle = get(this.props, 'activeToggle')
    const projectByID = get(this.props, 'projectByID')
    const projectSubmit = get(this.props, 'projectByID.profitSheet')
    const projectType = get(projectByID, 'project_type')
    const rSelected = get(this.props, 'rSelected')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const presale_snapshot_submit = get(projectSubmit, 'presale_snapshot.snapshot')
    const canShow = activeToggle === 2 || activeToggle === 3

    // const presale_snapshot = get(this.props, 'presale_snapshot')
    const isPresale = presale_snapshot && rSelected === 1

    const sum_total_cost = isPresale ? presale_snapshot.$sum_total_cost : get(projectByID, '$sum_total_cost', '-')
    const sum_total_standard_cost = isPresale ? presale_snapshot.$sum_total_standard_cost : get(projectByID, '$sum_total_standard_cost', '-')
    const sum_total_cost_with_cr = isPresale ? presale_snapshot.$sum_total_cost_with_cr : get(projectByID, '$sum_total_cost_with_cr', '-')
    const sum_total_standard_cost_with_cr = isPresale ? presale_snapshot.$sum_total_standard_cost_with_cr : get(projectByID, '$sum_total_standard_cost_with_cr', '-')

    // Maximum
    const total_overall_max_revenue = isPresale ? presale_snapshot.$total_overall_max_revenue : get(projectByID, '$total_overall_max_revenue', '-')
    const total_overall_max_gross_profit = isPresale ? presale_snapshot.$total_overall_max_gross_profit : get(projectByID, '$total_overall_max_gross_profit', '-')
    const total_overall_max_gross_profit_ratio = isPresale ? presale_snapshot.$total_overall_max_gross_profit_ratio : get(projectByID, '$total_overall_max_gross_profit_ratio', '-')
    const total_overall_max_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_overall_max_gross_profit_mandays_avg : get(projectByID, '$total_overall_max_gross_profit_mandays_avg', '-')

    // Minimum
    const total_overall_min_revenue = isPresale ? presale_snapshot.$total_overall_min_revenue : get(projectByID, '$total_overall_min_revenue', '-')
    const total_overall_min_gross_profit = isPresale ? presale_snapshot.$total_overall_min_gross_profit : get(projectByID, '$total_overall_min_gross_profit', '-')
    const total_overall_min_gross_profit_ratio = isPresale ? presale_snapshot.$total_overall_min_gross_profit_ratio : get(projectByID, '$total_overall_min_gross_profit_ratio', '-')
    const total_overall_min_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_overall_min_gross_profit_mandays_avg : get(projectByID, '$total_overall_min_gross_profit_mandays_avg', '-')

    // Contract
    const total_overall_contract_revenue = isPresale ? presale_snapshot.$total_overall_contract_revenue : get(projectByID, '$total_overall_contract_revenue', '-')
    const total_overall_contract_gross_profit = isPresale ? presale_snapshot.$total_overall_contract_gross_profit : get(projectByID, '$total_overall_contract_gross_profit', '-')
    const total_overall_contract_gross_profit_ratio = isPresale ? presale_snapshot.$total_overall_contract_gross_profit_ratio : get(projectByID, '$total_overall_contract_gross_profit_ratio', '-')
    const total_overall_contract_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_overall_contract_gross_profit_mandays_avg : get(projectByID, '$total_overall_contract_gross_profit_mandays_avg', '-')

    // Discount
    const total_overall_discount_price = isPresale ? presale_snapshot.$total_overall_discount_price : get(projectByID, '$total_overall_discount_price', '-')
    const total_overall_discount_ratio = isPresale ? presale_snapshot.$total_overall_discount_ratio : get(projectByID, '$total_overall_discount_ratio', '-')

    // CR
    const total_change_requests_price = isPresale ? presale_snapshot.$total_change_requests_price : get(projectByID, '$total_change_requests_price', '-')
    const total_change_requests_cost = isPresale ? presale_snapshot.$total_change_requests_cost : get(projectByID, '$total_change_requests_cost', '-')
    const total_change_requests_gross_profit = isPresale ? presale_snapshot.$total_change_requests_gross_profit : get(projectByID, '$total_change_requests_gross_profit', '-')
    const total_change_requests_gross_profit_ratio = isPresale ? presale_snapshot.$total_change_requests_gross_profit_ratio : get(projectByID, '$total_change_requests_gross_profit_ratio', '-')

    // Total
    const total_overall_contract_with_cr_price = isPresale ? presale_snapshot.$total_overall_contract_with_cr_price : get(projectByID, '$total_overall_contract_with_cr_price', '-')
    const total_overall_contract_with_cr_gross_profit = isPresale ? presale_snapshot.$total_overall_contract_with_cr_gross_profit : get(projectByID, '$total_overall_contract_with_cr_gross_profit', '-')
    const total_overall_contract_with_cr_gross_profit_ratio = isPresale ? presale_snapshot.$total_overall_contract_with_cr_gross_profit_ratio : get(projectByID, '$total_overall_contract_with_cr_gross_profit_ratio', '-')
    const total_overall_contract_with_cr_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_overall_contract_with_cr_gross_profit_mandays_avg : get(projectByID, '$total_overall_contract_with_cr_gross_profit_mandays_avg', '-')

    const standard_total_overall_discount_ratio = isPresale ? presale_snapshot.$standard_total_overall_discount_ratio : get(projectByID, '$standard_total_overall_discount_ratio', '-')
    // const standard_service_discount_ratio = isPresale ? presale_snapshot.$standard_service_discount_ratio : get(projectByID, '$standard_service_discount_ratio', '-')
    const standard_total_overall_max_gross_profit = isPresale ? presale_snapshot.$standard_total_overall_max_gross_profit : get(projectByID, '$standard_total_overall_max_gross_profit', '-')
    const standard_total_overall_max_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_overall_max_gross_profit_ratio : get(projectByID, '$standard_total_overall_max_gross_profit_ratio', '-')
    const standard_total_overall_max_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_overall_max_gross_profit_mandays_avg : get(projectByID, '$standard_total_overall_max_gross_profit_mandays_avg', '-')
    const standard_total_overall_min_gross_profit = isPresale ? presale_snapshot.$standard_total_overall_min_gross_profit : get(projectByID, '$standard_total_overall_min_gross_profit', '-')
    const standard_total_overall_min_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_overall_min_gross_profit_ratio : get(projectByID, '$standard_total_overall_min_gross_profit_ratio', '-')
    const standard_total_overall_min_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_overall_min_gross_profit_mandays_avg : get(projectByID, '$standard_total_overall_min_gross_profit_mandays_avg', '-')
    const standard_total_overall_contract_gross_profit = isPresale ? presale_snapshot.$standard_total_overall_contract_gross_profit : get(projectByID, '$standard_total_overall_contract_gross_profit', '-')
    const standard_total_overall_contract_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_overall_contract_gross_profit_ratio : get(projectByID, '$standard_total_overall_contract_gross_profit_ratio', '-')
    const standard_total_overall_contract_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_overall_contract_gross_profit_mandays_avg : get(projectByID, '$standard_total_overall_contract_gross_profit_mandays_avg', '-')
    const standard_total_overall_contract_with_cr_gross_profit = isPresale ? presale_snapshot.$standard_total_overall_contract_with_cr_gross_profit : get(projectByID, '$standard_total_overall_contract_with_cr_gross_profit', '-')
    const standard_total_overall_contract_with_cr_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_overall_contract_with_cr_gross_profit_ratio : get(projectByID, '$standard_total_overall_contract_with_cr_gross_profit_ratio', '-')
    const standard_total_overall_contract_with_cr_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_overall_contract_with_cr_gross_profit_mandays_avg : get(projectByID, '$standard_total_overall_contract_with_cr_gross_profit_mandays_avg', '-')

    const standard_total_overall_max_revenue = isPresale ? presale_snapshot.$standard_total_overall_max_revenue : get(projectByID, '$standard_total_overall_max_revenue', '-')
    const standard_total_overall_min_revenue = isPresale ? presale_snapshot.$standard_total_overall_min_revenue : get(projectByID, '$standard_total_overall_min_revenue', '-')
    const standard_total_overall_discount_price = isPresale ? presale_snapshot.$standard_total_overall_discount_price : get(projectByID, '$standard_total_overall_discount_price', '-')
    const standard_total_overall_contract_with_cr_price = isPresale ? presale_snapshot.$standard_total_overall_contract_with_cr_price : get(projectByID, '$standard_total_overall_contract_with_cr_price', '-')

    const project_summary_sga_allocation = isPresale ? presale_snapshot.$project_summary_sga_allocation : get(projectByID, '$project_summary_sga_allocation', '-')
    const project_summary_current_price_oi = isPresale ? presale_snapshot.$project_summary_current_price_oi : get(projectByID, '$project_summary_current_price_oi', '-')
    const project_summary_current_price_oi_ratio = isPresale ? presale_snapshot.$project_summary_current_price_oi_ratio : get(projectByID, '$project_summary_current_price_oi_ratio', '-')
    const project_summary_list_price_oi = isPresale ? presale_snapshot.$project_summary_list_price_oi : get(projectByID, '$project_summary_list_price_oi', '-')
    const project_summary_list_price_oi_ratio = isPresale ? presale_snapshot.$project_summary_list_price_oi_ratio : get(projectByID, '$project_summary_list_price_oi_ratio', '-')
    const project_summary_min_price_oi = isPresale ? presale_snapshot.$project_summary_min_price_oi : get(projectByID, '$project_summary_min_price_oi', '-')
    const project_summary_min_price_oi_ratio = isPresale ? presale_snapshot.$project_summary_min_price_oi_ratio : get(projectByID, '$project_summary_min_price_oi_ratio', '-')
    const project_summary_contract_price_oi = isPresale ? presale_snapshot.$project_summary_contract_price_oi : get(projectByID, '$project_summary_contract_price_oi', '-')
    const project_summary_contract_price_oi_ratio = isPresale ? presale_snapshot.$project_summary_contract_price_oi_ratio : get(projectByID, '$project_summary_contract_price_oi_ratio', '-')

    const standard_project_summary_sga_allocation = isPresale ? presale_snapshot.$standard_project_summary_sga_allocation : get(projectByID, '$standard_project_summary_sga_allocation', '-')
    const standard_project_summary_current_price_oi = isPresale ? presale_snapshot.$standard_project_summary_current_price_oi : get(projectByID, '$standard_project_summary_current_price_oi', '-')
    const standard_project_summary_current_price_oi_ratio = isPresale ? presale_snapshot.$standard_project_summary_current_price_oi_ratio : get(projectByID, '$standard_project_summary_current_price_oi_ratio', '-')
    const standard_project_summary_list_price_oi = isPresale ? presale_snapshot.$standard_project_summary_list_price_oi : get(projectByID, '$standard_project_summary_list_price_oi', '-')
    const standard_project_summary_list_price_oi_ratio = isPresale ? presale_snapshot.$standard_project_summary_list_price_oi_ratio : get(projectByID, '$standard_project_summary_list_price_oi_ratio', '-')
    const standard_project_summary_min_price_oi = isPresale ? presale_snapshot.$standard_project_summary_min_price_oi : get(projectByID, '$standard_project_summary_min_price_oi', '-')
    const standard_project_summary_min_price_oi_ratio = isPresale ? presale_snapshot.$standard_project_summary_min_price_oi_ratio : get(projectByID, '$standard_project_summary_min_price_oi_ratio', '-')
    const standard_project_summary_contract_price_oi = isPresale ? presale_snapshot.$standard_project_summary_contract_price_oi : get(projectByID, '$standard_project_summary_contract_price_oi', '-')
    const standard_project_summary_contract_price_oi_ratio = isPresale ? presale_snapshot.$standard_project_summary_contract_price_oi_ratio : get(projectByID, '$standard_project_summary_contract_price_oi_ratio', '-')

    const standard_total_pps_overall_price = isPresale ? presale_snapshot.$standard_total_pps_overall_price : get(projectByID, '$standard_total_pps_overall_price', '-')
    const standard_total_pps_overall_cost = isPresale ? presale_snapshot.$standard_total_pps_overall_cost : get(projectByID, '$standard_total_pps_overall_cost', '-')
    const standard_total_pps_overall_gross_profit = isPresale ? presale_snapshot.$standard_total_pps_overall_gross_profit : get(projectByID, '$standard_total_pps_overall_gross_profit', '-')
    const standard_total_pps_overall_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_pps_overall_gross_profit_ratio : get(projectByID, '$standard_total_pps_overall_gross_profit_ratio', '-')
    const standard_total_pps_overall_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_pps_overall_gross_profit_mandays_avg : get(projectByID, '$standard_total_pps_overall_gross_profit_mandays_avg', '-')

    const total_pps_overall_price = isPresale ? presale_snapshot.$total_pps_overall_price : get(projectByID, '$total_pps_overall_price', '-')
    const total_pps_overall_cost = isPresale ? presale_snapshot.$total_pps_overall_cost : get(projectByID, '$total_pps_overall_cost', '-')
    const total_pps_overall_gross_profit = isPresale ? presale_snapshot.$total_pps_overall_gross_profit : get(projectByID, '$total_pps_overall_gross_profit', '-')
    const total_pps_overall_gross_profit_ratio = isPresale ? presale_snapshot.$total_pps_overall_gross_profit_ratio : get(projectByID, '$total_pps_overall_gross_profit_ratio', '-')
    const total_pps_overall_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_pps_overall_gross_profit_mandays_avg : get(projectByID, '$total_pps_overall_gross_profit_mandays_avg', '-')

    //project submit
    const standard_total_pps_overall_price_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_overall_price : get(projectSubmit, '$standard_total_pps_overall_price', '-')
    const standard_total_pps_overall_cost_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_overall_cost : get(projectSubmit, '$standard_total_pps_overall_cost', '-')
    const standard_total_pps_overall_gross_profit_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_overall_gross_profit : get(projectSubmit, '$standard_total_pps_overall_gross_profit', '-')
    const standard_total_pps_overall_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_overall_gross_profit_ratio : get(projectSubmit, '$standard_total_pps_overall_gross_profit_ratio', '-')
    const standard_total_pps_overall_gross_profit_mandays_avg_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_overall_gross_profit_mandays_avg : get(projectSubmit, '$standard_total_pps_overall_gross_profit_mandays_avg', '-')

    const total_pps_overall_price_submit = isPresale ? presale_snapshot_submit.$total_pps_overall_price : get(projectSubmit, '$total_pps_overall_price', '-')
    const total_pps_overall_cost_submit = isPresale ? presale_snapshot_submit.$total_pps_overall_cost : get(projectSubmit, '$total_pps_overall_cost', '-')
    const total_pps_overall_gross_profit_submit = isPresale ? presale_snapshot_submit.$total_pps_overall_gross_profit : get(projectSubmit, '$total_pps_overall_gross_profit', '-')
    const total_pps_overall_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_overall_gross_profit_ratio : get(projectSubmit, '$total_pps_overall_gross_profit_ratio', '-')
    const total_pps_overall_gross_profit_mandays_avg_submit = isPresale ? presale_snapshot_submit.$total_pps_overall_gross_profit_mandays_avg : get(projectSubmit, '$total_pps_overall_gross_profit_mandays_avg', '-')

    // OI Standard
    const standard_total_pps_oi = isPresale ? presale_snapshot.$standard_total_pps_oi : get(projectByID, '$standard_total_pps_oi', '-')
    const standard_total_pps_oi_ratio = isPresale ? presale_snapshot.$standard_total_pps_oi_ratio : get(projectByID, '$standard_total_pps_oi_ratio', '-')

    const standard_total_pps_oi_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_oi : get(projectSubmit, '$standard_total_pps_oi', '-')
    const standard_total_pps_oi_ratio_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_oi_ratio : get(projectSubmit, '$standard_total_pps_oi_ratio', '-')

    // OI Actual
    const total_pps_oi = isPresale ? presale_snapshot.$total_pps_oi : get(projectByID, '$total_pps_oi', '-')
    const total_pps_oi_ratio = isPresale ? presale_snapshot.$total_pps_oi_ratio : get(projectByID, '$total_pps_oi_ratio', '-')

    const total_pps_oi_submit = isPresale ? presale_snapshot_submit.$total_pps_oi : get(projectSubmit, '$total_pps_oi', '-')
    const total_pps_oi_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_oi_ratio : get(projectSubmit, '$total_pps_oi_ratio', '-')

    // SGA Standard
    const standard_total_pps_sga = isPresale ? presale_snapshot.$standard_total_pps_sga : get(projectByID, '$standard_total_pps_sga', '-')

    const standard_total_pps_sga_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_sga : get(projectSubmit, '$standard_total_pps_sga', '-')

    // SGA Actual
    const total_pps_sga = isPresale ? presale_snapshot.$total_pps_sga : get(projectByID, '$total_pps_sga', '-')

    const total_pps_sga_submit = isPresale ? presale_snapshot_submit.$total_pps_sga : get(projectSubmit, '$total_pps_sga', '-')

    const fallbackNanOrInfinity = (number) => {
      return ['NaN', 'Infinity', '-Infinity'].includes(number) ? '0.00' : number
    }

    const twoDecimals = number => numeral(number).format('0,0.00')

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable bordered hover>
        <Header onClick={() => this.setState({ collapse_overall: !this.state.collapse_overall })}>
          <tr>
            <th>
              <Icon
                style={{ transform: this.state.collapse_overall ? 'rotate(180deg)' : 'rotate(270deg)' }}
                src={left_arrow}
                collapse={!this.state.collapse_overall}
              />
            </th>
            <th style={{ paddingLeft: 0 }}>Overall Revenue (Service + License/MA + Hardware)</th>
          </tr>
        </Header>
        <SubHeader style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr style={{ fontFamily: 'Gotham' }}>
            <HeadTable />
            <HeadTable>List Price<Text>(A)</Text></HeadTable>
            <HeadTable>Min Price<Text>(B)</Text></HeadTable>
            <HeadTable>Contract Price<Text>(C)</Text></HeadTable>
            <HeadTable>Diff. List Price<Text>(D = C - A)</Text></HeadTable>
            <HeadTable>CR Price<Text>(E)</Text></HeadTable>
            <HeadTable>Current Version<Text>(Forecast from PPS)</Text></HeadTable>
            <HeadTable>Latest Approved<Text>(Forecast from PPS)</Text></HeadTable>
          </tr>
        </SubHeader>
        <BodyTable style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          {(!(canSeeOverviewStandard || canSeeOverviewActual) || (activeToggle === 1 && projectType === CONSTANTS.SUPPORT) ?
            CONSTANTS.project_revenue_table_header.row.slice(0, CONSTANTS.project_revenue_table_header.row.length - 3)
            :
            CONSTANTS.project_revenue_table_header.row
          ).map((r, rowKey) => {
            if (canShow || (!canShow && rowKey === 0) || projectType === CONSTANTS.SUPPORT) {
              return (
                <tr key={shortid()}>
                  <td>{r}</td>
                  {CONSTANTS.project_revenue_table_header.column.map((c, key) => {
                    if (key !== 0) {
                      // Maximum
                      if (c === 'List Price (A)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{(() => { // sum_total_cost
                            if (projectType === CONSTANTS.SUPPORT) {
                              return total_overall_max_revenue
                            } else if (activeToggle === 1) return standard_total_overall_max_revenue
                            else if (activeToggle === 2) return standard_total_overall_max_revenue
                            return total_overall_max_revenue
                          })()}</td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{(() => { // sum_total_cost
                            if (projectType === CONSTANTS.SUPPORT) {
                              return sum_total_cost
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return sum_total_standard_cost
                            return sum_total_cost
                          })()}</td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{(() => { // total_overall_max_gross_profit
                            if (projectType === CONSTANTS.SUPPORT) {
                              return total_overall_max_gross_profit
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return standard_total_overall_max_gross_profit
                            return total_overall_max_gross_profit
                          })()}</td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(total_overall_max_gross_profit_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_overall_max_gross_profit_ratio))
                              return fallbackNanOrInfinity(twoDecimals(total_overall_max_gross_profit_ratio))
                            })()} %
                          </td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_overall_max_gross_profit_mandays_avg)
                              return fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'SGA Allocation') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_sga_allocation))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'OI') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_list_price_oi))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_list_price_oi))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_list_price_oi))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'List Price (A)' && r === 'OI%') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_list_price_oi_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_list_price_oi_ratio))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_list_price_oi_ratio))
                            })()} %
                          </td>
                        )
                      }

                      // Minimum
                      if (c === 'Min Price (B)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{(() => { // sum_total_cost
                            if (projectType === CONSTANTS.SUPPORT) {
                              return total_overall_min_revenue
                            } else if (activeToggle === 1) return standard_total_overall_min_revenue
                            else if (activeToggle === 2) return standard_total_overall_min_revenue
                            return total_overall_min_revenue
                          })()}</td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{(() => { // sum_total_cost
                            if (projectType === CONSTANTS.SUPPORT) {
                              return sum_total_cost
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return sum_total_standard_cost
                            return sum_total_cost
                          })()}</td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{(() => { // total_overall_min_gross_profit
                            if (projectType === CONSTANTS.SUPPORT) {
                              return total_overall_min_gross_profit
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return standard_total_overall_min_gross_profit
                            return total_overall_min_gross_profit
                          })()}</td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_min_gross_profit_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(total_overall_min_gross_profit_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_overall_min_gross_profit_ratio))
                              return fallbackNanOrInfinity(twoDecimals(total_overall_min_gross_profit_ratio))
                            })()} %
                          </td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()} >
                            {(() => { // fallbackNanOrInfinity(total_overall_min_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(total_overall_min_gross_profit_mandays_avg)
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_overall_min_gross_profit_mandays_avg)
                              return fallbackNanOrInfinity(total_overall_min_gross_profit_mandays_avg)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'SGA Allocation') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_sga_allocation))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'OI') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_min_price_oi))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_min_price_oi))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_min_price_oi))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Min Price (B)' && r === 'OI%') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_min_price_oi_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_min_price_oi_ratio))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_min_price_oi_ratio))
                            })()} %
                          </td>
                        )
                      }

                      // Contract
                      if (c === 'Contract Price (C)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{total_overall_contract_revenue}</td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{(() => { // sum_total_cost
                            if (projectType === CONSTANTS.SUPPORT) {
                              return sum_total_cost
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return sum_total_standard_cost
                            return sum_total_cost
                          })()}</td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{(() => { // total_overall_contract_gross_profit
                            if (projectType === CONSTANTS.SUPPORT) {
                              return total_overall_contract_gross_profit
                            } else if (activeToggle === 1) return 1
                            else if (activeToggle === 2) return standard_total_overall_contract_gross_profit
                            return total_overall_contract_gross_profit
                          })()}</td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_contract_gross_profit_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(total_overall_contract_gross_profit_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_overall_contract_gross_profit_ratio))
                              return fallbackNanOrInfinity(twoDecimals(total_overall_contract_gross_profit_ratio))
                            })()} %
                          </td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_contract_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(total_overall_contract_gross_profit_mandays_avg)
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_overall_contract_gross_profit_mandays_avg)
                              return fallbackNanOrInfinity(total_overall_contract_gross_profit_mandays_avg)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'SGA Allocation') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_max_gross_profit_mandays_avg)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_sga_allocation))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_sga_allocation))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'OI') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_contract_gross_profit_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_contract_price_oi))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_contract_price_oi))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_contract_price_oi))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Contract Price (C)' && r === 'OI%') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_contract_gross_profit_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return fallbackNanOrInfinity(twoDecimals(project_summary_contract_price_oi_ratio))
                              } else if (activeToggle === 1) return 1
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_project_summary_contract_price_oi_ratio))
                              return fallbackNanOrInfinity(twoDecimals(project_summary_contract_price_oi_ratio))
                            })()} %
                          </td>
                        )
                      }

                      // Discount
                      if (c === 'Diff. List Price (D = C - A)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_discount_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return `${fallbackNanOrInfinity(total_overall_discount_price)} (${fallbackNanOrInfinity(total_overall_discount_ratio)} %)`
                              } else if (activeToggle === 1) return `${fallbackNanOrInfinity(standard_total_overall_discount_price)} (${fallbackNanOrInfinity(standard_total_overall_discount_ratio)} %)`
                              else if (activeToggle === 2) return `${fallbackNanOrInfinity(standard_total_overall_discount_price)} (${fallbackNanOrInfinity(standard_total_overall_discount_ratio)} %)`
                              return `${fallbackNanOrInfinity(total_overall_discount_price)} (${fallbackNanOrInfinity(total_overall_discount_ratio)} %)`
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Diff. List Price (D = C - A)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>
                            {(() => { // fallbackNanOrInfinity(total_overall_discount_ratio)
                              if (projectType === CONSTANTS.SUPPORT) {
                                return '-'
                              } else if (activeToggle === 1) return `-`
                              else if (activeToggle === 2) return '-'
                              return '-'
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Diff. List Price (D = C - A)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }
                      if (c === 'Diff. List Price (D = C - A)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }
                      if (c === 'Diff. List Price (D = C - A)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }
                      if (c === 'Diff. List Price (D = C - A)' && (r === 'SGA Allocation' || r === 'OI' || r === 'OI%')) {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }

                      // CR
                      if (c === 'CR Price (E)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{total_change_requests_price}</td>
                        )
                      }
                      if (c === 'CR Price (E)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{total_change_requests_cost}</td>
                        )
                      }
                      if (c === 'CR Price (E)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{total_change_requests_gross_profit}</td>
                        )
                      }
                      if (c === 'CR Price (E)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>{total_change_requests_gross_profit_ratio} %</td>
                        )
                      }
                      if (c === 'CR Price (E)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }
                      if (c === 'CR Price (E)' && (r === 'SGA Allocation' || r === 'OI' || r === 'OI%')) {
                        return (
                          <td key={shortid()}>-</td>
                        )
                      }

                      // Total
                      if (c === 'Current Version (Forecast from PPS)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_price
                            else if (activeToggle === 2) return standard_total_pps_overall_price
                            else return total_pps_overall_price
                          })()}</td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_cost
                            else if (activeToggle === 2) return standard_total_pps_overall_cost
                            else return total_pps_overall_cost
                          })()}</td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_gross_profit
                            else if (activeToggle === 2) return standard_total_pps_overall_gross_profit
                            else return total_pps_overall_gross_profit
                          })()}</td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_overall_gross_profit_ratio))
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_overall_gross_profit_ratio))
                              else return fallbackNanOrInfinity(twoDecimals(total_pps_overall_gross_profit_ratio))
                            })()} %
                          </td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_overall_gross_profit_mandays_avg)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_overall_gross_profit_mandays_avg)
                              else return fallbackNanOrInfinity(total_pps_overall_gross_profit_mandays_avg)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'SGA Allocation') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_sga))
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_sga))
                              else return fallbackNanOrInfinity(twoDecimals(total_pps_sga))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'OI') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_oi)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_oi)
                              else return fallbackNanOrInfinity(total_pps_oi)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Current Version (Forecast from PPS)' && r === 'OI%') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_oi_ratio)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_oi_ratio)
                              else return fallbackNanOrInfinity(total_pps_oi_ratio)
                            })()} %
                          </td>
                        )
                      }

                      // Forecast
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'Revenue') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_price_submit
                            else if (activeToggle === 2) return standard_total_pps_overall_price_submit
                            else return total_pps_overall_price_submit
                          })()}</td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'Total Cost') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_cost_submit
                            else if (activeToggle === 2) return standard_total_pps_overall_cost_submit
                            else return total_pps_overall_cost_submit
                          })()}</td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'Gross Profit') {
                        return (
                          <td key={shortid()}>{(() => {
                            if (activeToggle === 1) return standard_total_pps_overall_gross_profit_submit
                            else if (activeToggle === 2) return standard_total_pps_overall_gross_profit_submit
                            else return total_pps_overall_gross_profit_submit
                          })()}</td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'Gross Profit Ratio') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_overall_gross_profit_ratio_submit))
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_overall_gross_profit_ratio_submit))
                              else return fallbackNanOrInfinity(twoDecimals(total_pps_overall_gross_profit_ratio_submit))
                            })()} %
                          </td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'GP/MD') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_overall_gross_profit_mandays_avg_submit)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_overall_gross_profit_mandays_avg_submit)
                              else return fallbackNanOrInfinity(total_pps_overall_gross_profit_mandays_avg_submit)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'SGA Allocation') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_sga_submit))
                              else if (activeToggle === 2) return fallbackNanOrInfinity(twoDecimals(standard_total_pps_sga_submit))
                              else return fallbackNanOrInfinity(twoDecimals(total_pps_sga_submit))
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'OI') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_oi_submit)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_oi_submit)
                              else return fallbackNanOrInfinity(total_pps_oi_submit)
                            })()}
                          </td>
                        )
                      }
                      if (c === 'Latest Approved (Forecast from PPS)' && r === 'OI%') {
                        return (
                          <td key={shortid()}>
                            {(() => {
                              if (activeToggle === 1) return fallbackNanOrInfinity(standard_total_pps_oi_ratio_submit)
                              else if (activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_oi_ratio_submit)
                              else return fallbackNanOrInfinity(total_pps_oi_ratio_submit)
                            })()} %
                          </td>
                        )
                      }

                      return (
                        <td key={shortid()}>{c}</td>
                      )
                    }
                    return null
                  })
                  }
                </tr>
              )
            }
            return null
          })
          }
        </BodyTable>
      </CustomTable>
    )
  }
}

const CustomTable = styled(Table)`
  background: white;
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border-bottom: 1px solid #CCCCCC !important;
  } tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE}
  } tbody td {
    font-family: 'NotoSans' !important;
    font-variant-numeric: tabular-nums;
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    border: none ;
    text-align:right;
    justify-content: flex-end;
  } thead th {
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    border: none ;
    text-align:right;
    justify-content: flex-end;
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 225px);
  overflow-y:scroll;
  border-top: none !important;
  border: 1px solid #CCCCCC ;
  background-color: #F9F9F9;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const Text = styled.p`
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: 10px;
  margin-bottom: 0px;
`
const Icon = styled.img`
  width : 10px ;
  height : 10px;
  margin-left: 1%;
  margin-right: 1%;
  cursor: pointer;
`
const SubHeader = styled.thead`
  background: white;
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const Header = styled.thead`
  height: 50px;
  background: #404040;
  color: white;
  display: flex !important;
  align-items: center;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-overview/table-project-revenue.js